import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { motion } from 'framer-motion';
import { Cpu, CloudFill } from 'react-bootstrap-icons';
import { useTheme } from '../contexts/ThemeContext'; // <-- 1. Import Theme context

function AppFooter() {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme(); // <-- 2. Get the current theme

  // Animation variant for links dynamically adjusting to theme colors
  const linkHover = {
    rest: { 
      y: 0, 
      color: theme === 'light' ? '#495057' : 'rgba(255,255,255,0.55)' // Slightly darkened the resting text in Light mode for better contrast
    },
    hover: { 
      y: -3, 
      color: theme === 'light' ? '#000000' : '#ffffff', // Solid black for light hover, solid white for dark hover
      transition: { duration: 0.2 } 
    }
  };

  return (
    <footer className={`py-5 mt-auto ${theme === 'light' ? 'bg-light border-top text-dark' : 'bg-dark text-light'}`}>
      <Container>
        <Row className="gy-4 justify-content-between align-items-center">
          
          {/* Section 1: Brand & Tech Stack */}
          <Col md={5} className="text-center text-md-start">
            <h5 className={`fw-bold mb-2 ${theme === 'light' ? 'text-dark' : 'text-white'}`}>MultAI Technologies</h5>
            <div className={`small mb-3 ${theme === 'light' ? 'text-muted' : 'text-white-50'}`}>
              <p className="mb-1">
                <Cpu className="me-2" />
                Powered by <strong>Vertex AI ADK</strong> & Python
              </p>
              <p className="mb-0">
                <CloudFill className="me-2" />
                Running securely on <strong>Google Cloud Platform</strong>
              </p>
            </div>
            <small className={`opacity-75 ${theme === 'light' ? 'text-muted' : 'text-white-50'}`}>
              &copy; {currentYear} All rights reserved.
            </small>
          </Col>

          {/* Section 2: Navigation Links */}
          <Col md={7}>
            <Nav className="justify-content-center justify-content-md-end flex-wrap gap-3">
              <FooterLink to="/" label="Home" variants={linkHover} />
              <FooterLink to="/business-roadmap" label="Business Roadmap" variants={linkHover} />
              <FooterLink to="/feature-roadmap" label="Feature Roadmap" variants={linkHover} />
              <FooterLink to="/changelog" label="Changelog" variants={linkHover} />
              <FooterLink to="/team" label="Team" variants={linkHover} />
            </Nav>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

// Helper Component for Animated Links
const FooterLink = ({ to, label, variants }) => {
  return (
    <LinkContainer to={to}>
      <motion.div
        initial="rest"
        whileHover="hover"
        animate="rest"
      >
        <Nav.Link 
          as={motion.a} 
          variants={variants}
          className="px-0 py-1"
          style={{ fontSize: '0.95rem' }}
        >
          {label}
        </Nav.Link>
      </motion.div>
    </LinkContainer>
  );
};

export default AppFooter;
